import React from "react";
import PropTypes from "prop-types";
import {getDataAttributes} from "./Component";

const Button = (props) => {

  const _className = () => {
    return (props.className ? " " + props.className : "")
      + (props.color ? " is-" + props.color : "")
      + (props.size ? " is-" + props.size : "")
      + (props.isLight ? " is-light" : "")
      + (props.isOutlined ? " is-outlined" : "")
      + (props.isRounded ? " is-rounded" : "")
      + (props.isLoading ? " is-loading" : "")
      + (props.isFullWidth ? " is-fullwidth" : "")
      + (props.isInverted ? " is-inverted" : "");
  }

  return (
    <button type={props.isSubmit ? "submit" : "button"}
            onClick={props.onClick}
            disabled={props.disabled || false}
            className={"button " + _className()}
            {...getDataAttributes(props)}>
      {props.label}
      {props.icon && <span className={"icon fz solid " + props.icon}></span>}
    </button>
  )
}

Button.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.oneOf(["primary", "link", "info", "success", "warning", "danger", "white", "light", "dark", "black", "text", "default"]),
  isLight: PropTypes.bool,
  isOutlined: PropTypes.bool,
  isRounded: PropTypes.bool,
  isLoading: PropTypes.bool,
  isInverted: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["small", "normal", "medium", "large"]),
  isSubmit: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
